import React from 'react'
import ProjectList from '../containers/ProjectList'

const Projects = () => {
  return (
    <div className='project'>
      <ProjectList/>
    </div>
  )
}

export default Projects